<template>
<div ref="dropdownRef" class="dropdown" :class="dropdownPositionClass">
  <div tabindex="0" role="button" class="btn btn-circle btn-ghost btn-xs text-info">
    <svg
      tabindex="0"
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      class="h-4 w-4 stroke-current">
      <path
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="2"
        d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></path>
    </svg>
  </div>
  <div
    tabindex="0"
    class="card compact dropdown-content bg-base-100 rounded-box z-[1] shadow"
    style="width:auto; max-width:90vw;">
    <div tabindex="0" class="card-body w-full" style="min-width: 14rem;">
      <slot></slot>
      
    </div>
  </div>
</div>
</template>

<script setup>
  import { ref, computed, onMounted } from 'vue';
  import { useSidebar } from "@/store/sidebar";
  import { Icon } from "@iconify/vue/dist/offline";
  import MenuAccordion from "./MenuAccordion.vue";
  import { Tooltip } from 'equal-vue'

  const props = defineProps({
    position: {
      type: String,
      default: 'end',
      validator: (value) => [
        'top', 'bottom', 'left', 'right', 'end'
      ].includes(value) !== false
    }
  });


const positionRef = ref(props.position);
const dropdownRef = ref(null);

onMounted(() => {
  if (props.position !== 'end') {
    return;
  }
  const rect = dropdownRef.value?.getBoundingClientRect();
  if (rect !== undefined && rect !== null) {
    positionRef.value = rect.left > window.innerWidth / 2 ? 'left' : 'right';
  }
});

  const dropdownPositionClass = computed(() => {
    const pos = positionRef.value;
    switch (pos) {
      case 'top':
        return 'dropdown-top';
      case 'bottom':
        return 'dropdown-bottom';
      case 'left':
        return 'dropdown-start';
      case 'right':
        return 'dropdown-end';
      case 'end':
      default:
        return 'dropdown-end';
    }
  });
</script>
